import React, { useEffect, useState } from 'react';
import { MenuIcon, X, ChevronRight } from 'lucide-react';
import Button from '../ui/Button';
const Navbar = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      const isScrolled = window.scrollY > 20;
      if (isScrolled !== scrolled) {
        setScrolled(isScrolled);
      }
    };
    window.addEventListener('scroll', handleScroll);
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, [scrolled]);
  return <nav className={`fixed w-full top-0 z-50 transition-all duration-300 ${scrolled ? 'py-3 bg-white shadow-md' : 'py-5 bg-white/90 backdrop-blur-sm'}`} data-id="element-90">
      <div className="max-w-7xl mx-auto px-6 md:px-12 lg:px-24 flex justify-between items-center" data-id="element-91">
        <div className="flex items-center" data-id="element-92">
          <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/sXfj2SQURVNrryAb38TWx4/Screenshot_2025-10-09_at_11.43.06_AM.png" alt="Shepherd Flow AI Logo" className={`transition-all duration-300 ${scrolled ? 'h-9 md:h-10' : 'h-10 md:h-12'}`} data-id="element-93" />
        </div>
        <div className="hidden md:flex items-center space-x-8" data-id="element-94">
          <a href="#how-it-works" className="text-gray-700 hover:text-[#3D52A0] transition-colors relative group" data-id="element-95">
            How It Works
            <span className="absolute bottom-0 left-0 w-0 h-0.5 bg-[#3D52A0] transition-all duration-300 group-hover:w-full" data-id="element-96"></span>
          </a>
          <a href="#about" className="text-gray-700 hover:text-[#3D52A0] transition-colors relative group" data-id="element-97">
            About
            <span className="absolute bottom-0 left-0 w-0 h-0.5 bg-[#3D52A0] transition-all duration-300 group-hover:w-full" data-id="element-98"></span>
          </a>
          <a href="#features" className="text-gray-700 hover:text-[#3D52A0] transition-colors relative group" data-id="element-99">
            Features
            <span className="absolute bottom-0 left-0 w-0 h-0.5 bg-[#3D52A0] transition-all duration-300 group-hover:w-full" data-id="element-100"></span>
          </a>
          <a href="https://app.shepherdflow.ai/signin" className="text-gray-700 hover:text-[#3D52A0] font-medium transition-colors relative group" data-id="element-101">
            Login
            <span className="absolute bottom-0 left-0 w-0 h-0.5 bg-[#3D52A0] transition-all duration-300 group-hover:w-full" data-id="element-102"></span>
          </a>
          <a href="https://app.shepherdflow.ai/signup" data-id="element-103">
            <Button variant="accent" size="md" icon={<ChevronRight size={16} data-id="element-105" />} data-id="element-104">
              Sign Up Now - It's FREE
            </Button>
          </a>
        </div>
        <div className="md:hidden" data-id="element-106">
          <button onClick={() => setIsMenuOpen(!isMenuOpen)} aria-label="Toggle menu" className="p-1 rounded-full hover:bg-gray-100 transition-colors" data-id="element-107">
            {isMenuOpen ? <X size={24} data-id="element-108" /> : <MenuIcon size={24} data-id="element-109" />}
          </button>
        </div>
      </div>
      {/* Mobile menu */}
      {isMenuOpen && <div className="md:hidden absolute top-full left-0 w-full bg-white shadow-md py-4 px-6 flex flex-col space-y-4 animate-fade-in" data-id="element-110">
          <a href="#how-it-works" className="text-gray-700 hover:text-[#3D52A0] transition-colors py-2 border-b border-gray-100" data-id="element-111">
            How It Works
          </a>
          <a href="#about" className="text-gray-700 hover:text-[#3D52A0] transition-colors py-2 border-b border-gray-100" data-id="element-112">
            About
          </a>
          <a href="#features" className="text-gray-700 hover:text-[#3D52A0] transition-colors py-2 border-b border-gray-100" data-id="element-113">
            Features
          </a>
          <a href="https://app.shepherdflow.ai/signin" className="text-gray-700 hover:text-[#3D52A0] transition-colors py-2 border-b border-gray-100" data-id="element-114">
            Login
          </a>
          <a href="https://app.shepherdflow.ai/signup" data-id="element-115">
            <Button variant="accent" size="md" icon={<ChevronRight size={16} data-id="element-117" />} className="w-full" data-id="element-116">
              Sign Up Now - It's FREE
            </Button>
          </a>
        </div>}
    </nav>;
};
export default Navbar;